import React, { useEffect, useState } from 'react'
import {
  Routes, Route, BrowserRouter, useParams
} from 'react-router-dom'
import { Provider } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { ModalProvider } from 'styled-react-modal'

import LoadingModal from '@components/loading/loadingModal'

import LoginContainer from '@containers/login'
import InsuranceContainer from '@containers/insurance'
import { WindowContextProvider } from '@components/windowContextProvider'

import AuthUtil from '@util/AuthUtil'
import store from '@stores/store'
import { AppContainer } from './styles'
import { getAuth } from '@actions/auth'
import GlobalStyle from '@settings/globalStyles'
import ConnectionStatus from '../ConnectionStatus'

AuthUtil.init()

function App() {
  const url = window.location.pathname.split('/').pop()
  const [loading, setLoading] = useState(true)

  const { insurance } = useParams()

  useEffect(() => {
    if (store.getState().user.loggedIn) {
      setLoading(true)
      store.dispatch(getAuth(() => setLoading(false)))
    } else {
      setLoading(false)
    }
  }, [url])

  useEffect(() => {
    if (url.length === 0) {
      window.location = '/unimed-assis/acompanhamento'
    }
  }, [])

  if (
    !AuthUtil.getAccessToken()
    && window.location.href.includes('acompanhamento/')
  ) {
    window.location = `/${insurance}/acompanhamento`
    return null
  }

  return (
    <Provider store={store}>
      <WindowContextProvider>
        <ModalProvider>
          <AppContainer>
            <GlobalStyle />
            <ConnectionStatus />
            <link
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
              rel="stylesheet"
            />
            {loading ? (
              <LoadingModal isOpen={loading} />
            ) : (
              <BrowserRouter>
                <Routes>
                  <Route
                    element={<InsuranceContainer />}
                    path="/:insurance/acompanhamento/*"
                  />
                  <Route element={<LoginContainer />} path="/:insurance/*" />
                </Routes>
              </BrowserRouter>
            )}
          </AppContainer>
        </ModalProvider>
        <ToastContainer
          position="top-left"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          pauseOnFocusLoss
          pauseOnHover
        />
      </WindowContextProvider>
    </Provider>
  )
}

export default App
